/* Bagifi: make product-card colour swatches interactive on every page,
   including the async-loaded "You may also like" recommendations, where the
   card snippet's own {% javascript %} is not bundled. Delegation on document
   so it also covers cards injected after load. Guard shares the same flag as
   the snippet so it only ever binds once. */
(function () {
  if (window.__bagifiCardSwatchesInit) return;
  window.__bagifiCardSwatchesInit = true;

  function activateSwatch(swatch) {
    var wrapper = swatch.closest('.card-wrapper');
    if (!wrapper) return;

    var group = swatch.closest('.card-color-swatches');
    if (group) {
      group.querySelectorAll('.card-color-swatch--active').forEach(function (el) {
        el.classList.remove('card-color-swatch--active');
      });
    }
    swatch.classList.add('card-color-swatch--active');

    var img = wrapper.querySelector('.card__main-image');
    var newSrc = swatch.getAttribute('data-swatch-image');
    if (img && newSrc) {
      var newSrcset = swatch.getAttribute('data-swatch-srcset');
      img.src = newSrc;
      if (newSrcset) img.srcset = newSrcset;
    }
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.card-color-swatch');
    if (!swatch) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    activateSwatch(swatch);
  }, true);

  document.addEventListener('mouseover', function (event) {
    var swatch = event.target.closest('.card-color-swatch');
    if (!swatch) return;
    activateSwatch(swatch);
  }, { passive: true });
})();
